import { Parser } from '~/api';
import { DatabaseHost } from '~/api/models';
import { useModelsStore } from '~/stores';
import RequestService from './request';

interface CreateDatabaseHostRequest {
    name: string;
    host: string;
    port: number;
    username: string;
    password: string;
    phpmyadmin_url: string;
}

type UpdateDatabaseHostRequest = CreateDatabaseHostRequest;

interface DeleteDatabaseHostRequest {
    id: number;
    force: boolean;
}

class DatabaseHostsService {
    getAll(req: PaginatableRequest): Promise<ListResponse> {
        return RequestService.get('/database-hosts', {
            ...req,
            include: ['node', 'databasesCount'],
        }).then(Parser.parse);
    }

    get(): Promise<DatabaseHost> {
        return RequestService.get('/database-hosts/:databaseHost', {
            include: ['node'],
        }).then(Parser.parse);
    }

    getDatabases(req: PaginatableRequest): Promise<ListResponse> {
        return RequestService.get('/database-hosts/:databaseHost/databases', {
            ...req,
            include: ['server'],
        }).then(Parser.parse);
    }

    create(data: CreateDatabaseHostRequest): Promise<DatabaseHost> {
        return RequestService.post('/database-hosts', data).then(Parser.parse);
    }

    update(data: UpdateDatabaseHostRequest): Promise<DatabaseHost> {
        return RequestService.put('/database-hosts/:databaseHost?include=node', data)
            .then(Parser.parse)
            .then((host: DatabaseHost) => {
                useModelsStore().refreshModel('databaseHost');

                return host;
            });
    }

    delete(data: DeleteDatabaseHostRequest): Promise<void> {
        return RequestService.delete(`/database-hosts/${data.id}`, {
            data: {
                force: data.force,
            },
        });
    }
}

export default new DatabaseHostsService();
